// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3U9Kf","col":"styles_col__LblCe","fulfillmentStatus":"styles_fulfillmentStatus__16Ix-","emailCol":"styles_emailCol__14gtj"};